"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ItemsContainer = _interopRequireDefault(require("../ItemsContainer"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _styledComponents = require("styled-components");
var _ = require("../../..");
var _styled = require("./styled");
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const MenuItem = _ref => {
  let {
    currentPath = '',
    hidden = false,
    item = {},
    indentation = 10,
    onClick
  } = _ref;
  const [expanded, setExpanded] = (0, _react.useState)(false);
  const {
    dangerColor,
    overPrimaryColor,
    primaryColor
  } = (0, _styledComponents.useTheme)();
  const {
    disabled = false,
    display = true,
    icon,
    iconColor,
    items = [],
    notification,
    path,
    text = ''
  } = item;
  const currentDisabled = disabled || hidden;
  const isActive = path && path === currentPath;
  const isSubmenu = !(0, _isEmpty.default)(items);
  if (!display) return null;
  const handleContainerClick = function () {
    let event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (currentDisabled) return;
    if (isSubmenu) return setExpanded(expanded => !expanded);
    const {
      altKey,
      metaKey
    } = event;
    onClick(_objectSpread(_objectSpread({}, item), {}, {
      altKey,
      metaKey
    }));
  };
  const handleContainerKey = event => {
    const {
      key
    } = event;
    if (key !== 'Enter') return;
    handleContainerClick();
  };
  const containerProps = {
    active: isActive,
    disabled: currentDisabled,
    indentation,
    onClick: handleContainerClick,
    onKeyPress: handleContainerKey
  };
  const activeProps = !isActive ? {} : {
    color: overPrimaryColor
  };
  const isNotificationNumber = typeof notification === 'number';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Container, _objectSpread(_objectSpread({}, containerProps), {}, {
      tabIndex: !currentDisabled ? '0' : '-1',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Section, {
        flex: 1,
        children: icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_.MaterialIcon, _objectSpread(_objectSpread({
          color: iconColor !== null && iconColor !== void 0 ? iconColor : primaryColor
        }, activeProps), {}, {
          icon: icon,
          size: 18
        }))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Section, {
        flex: 6,
        padding: "0px 0px 0px 5px",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Text, _objectSpread(_objectSpread({}, activeProps), {}, {
          fontSize: "11px",
          fontWeight: 500,
          children: text.toUpperCase()
        }))
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Section, {
        flex: 1,
        justifyContent: "flex-end",
        padding: "0px 5px 0px 0px",
        children: [!!notification && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_.Badge, {
          color: dangerColor,
          padding: isNotificationNumber ? '0px 8px 0px 8px' : undefined,
          children: [isNotificationNumber && /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Text, {
            color: "#FFFFFF",
            children: notification.toString()
          }), typeof notification === 'string' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_.MaterialIcon, {
            color: "#FFFFFF",
            icon: notification,
            size: 12
          })]
        }), !notification && isSubmenu && /*#__PURE__*/(0, _jsxRuntime.jsx)(_.MaterialIcon, {
          icon: expanded ? 'expand_less' : 'expand_more',
          size: 18
        })]
      })]
    })), !(0, _isEmpty.default)(items) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ItemsContainer.default, {
      expanded: expanded,
      children: items.map((item, index) => {
        const itemProps = {
          currentPath,
          hidden: hidden || !expanded,
          indentation: indentation + 10,
          item,
          onClick
        };
        return /*#__PURE__*/(0, _react.createElement)(MenuItem, _objectSpread(_objectSpread({}, itemProps), {}, {
          key: index
        }));
      })
    })]
  });
};
MenuItem.propTypes = {
  currentPath: _propTypes.default.string,
  hidden: _propTypes.default.bool,
  indentation: _propTypes.default.number,
  item: _propTypes.default.shape({
    disabled: _propTypes.default.bool,
    display: _propTypes.default.bool,
    icon: _propTypes.default.string,
    items: _propTypes.default.array,
    notification: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    path: _propTypes.default.string,
    text: _propTypes.default.string
  }),
  onClick: _propTypes.default.func
};
var _default = exports.default = MenuItem;